module.exports = __webpack_public_path__ + "img/sitelogo.03f4aae9.png";